import {PromoType, UserSubscription} from '@lookiero/promocodes-front';
import {PromoType as UafPromoType} from '@domain/model/PromoCode/PromoCode';
import {MODALITY, Modality} from '@domain/model/Account/Subscription/Subscription';

export const PROMO_MODALITY_MAP: Record<Modality, UserSubscription> = {
  [MODALITY.ON_DEMAND]: UserSubscription.OCCASIONAL,
  [MODALITY.MONTHLY]: UserSubscription.MONTHLY,
  [MODALITY.BIMONTHLY]: UserSubscription.BIMONTHLY,
  [MODALITY.QUARTERLY]: UserSubscription.QUARTERLY,
};

export const PROMO_TYPE_MAP: Record<UafPromoType, PromoType> = {
  [UafPromoType.MANUAL]: PromoType.Manual,
  [UafPromoType.URL]: PromoType.URL,
  [UafPromoType.SITE]: PromoType.Site,
  [UafPromoType.MULTIBOX]: PromoType.MultiBox,
};
